export default __webpack_public_path__ + "static/media/LE PORTAGE DE BAGAGE.1a537b64.svg";